export default function Menu() {
	// Find the mobile menu trigger, mobile menu, and mobile item triggers
	const mobileMenuTrigger = document.querySelector('.js-mobile-menu-trigger')
	const mobileMenu = document.querySelector('.js-mobile-menu')

	// Toggle the mobile menu
	if (mobileMenuTrigger) {
		mobileMenuTrigger.addEventListener('click', () => {
			if (mobileMenu) {
				mobileMenu.classList.toggle('active')
			}

			const icon = mobileMenuTrigger.querySelector('ion-icon')
			const text = mobileMenuTrigger.querySelector('.js-menu-trigger-text')

			if (icon && text) {
				setTimeout(() => {
					const newIconAndText = icon.getAttribute('name') === 'menu' ? 'close' : 'menu';
					icon.setAttribute('name', newIconAndText)
					text.innerHTML = newIconAndText
				}, 200);
			}
		});
	}
}
